/** @jsxImportSource theme-ui */

import { BaseIcon } from './base-icon'

export const CheckMarkIcon: BaseIcon = ({ ...props }) => {
  return (
    <svg
      sx={{ size: 5, flexShrink: 0, color: 'primary' }}
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M140.6 21.15C154.1 7.652 172.4 .0664 191.5 .0664H320.5C339.6 .0664 357.9 7.652 371.4 21.15L490.8 140.6C504.3 154.1 511.9 172.4 511.9 191.5V320.5C511.9 339.6 504.3 357.9 490.8 371.4L371.4 490.8C357.9 504.3 339.6 511.9 320.5 511.9H191.5C172.4 511.9 154.1 504.3 140.6 490.8L21.15 371.4C7.651 357.9 .0653 339.6 .0653 320.5V191.5C.0653 172.4 7.651 154.1 21.15 140.6L140.6 21.15zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"
      />
    </svg>
  )
}
